var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.showHeader)?_c('Header'):_vm._e(),_c('router-view',{attrs:{"id":"content"}}),(_vm.showHeader)?_c('Footer'):_vm._e(),_c('Notification'),_c('CookieNotification')],1)}
var staticRenderFns = []

export { render, staticRenderFns }